"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const actionCreators = __importStar(require("./actions"));
const initialState = {
    show: false,
    x: 0,
    y: 0,
    scalable: true,
    angled: false,
    isMultiSelectMode: false,
    selectedIds: [],
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    if (action.type === (0, typesafe_actions_1.getType)(actionCreators.toggleContextMenu)) {
        draft.x = action.payload.x;
        draft.y = action.payload.y;
        draft.show = action.payload.show;
        draft.isMultiSelectMode = action.payload.isMultiSelectMode;
        if (action.payload.isMultiSelectMode) {
            draft.selectedIds = action.payload.selectedIds;
        }
        draft.scalable = action.payload.scalable;
        draft.angled = action.payload.angled;
    }
});
exports.default = reducer;
